/**
 * Utility function to safely convert any error to a displayable string
 * Prevents React from trying to render error objects
 */
export const getErrorMessage = (error) => {
  // If it's already a string, return it
  if (typeof error === 'string') {
    return error;
  }

  // If it's null or undefined, return a default message
  if (!error) {
    return 'An error occurred';
  }

  // If it's an Error object or has a message property
  if (error.message) {
    return error.message;
  }

  // If it has an error property
  if (error.error) {
    return typeof error.error === 'string' ? error.error : error.error.message || 'An error occurred';
  }

  // If it has a details property
  if (error.details) {
    return typeof error.details === 'string' ? error.details : error.details.message || 'An error occurred';
  }

  // If it has a data property (common in API errors)
  if (error.data) {
    return typeof error.data === 'string' ? error.data : error.data.message || 'An error occurred';
  }

  // Try to stringify the error (last resort)
  try {
    const stringified = JSON.stringify(error);
    if (stringified && stringified !== '{}') {
      return stringified;
    }
  } catch (e) {
    // If JSON.stringify fails, fall through to default
  }

  // Default fallback
  return 'An error occurred';
};

/**
 * Utility function to safely render error messages in React components
 */
export const ErrorMessage = ({ error }) => {
  const message = getErrorMessage(error);
  return <>{message}</>;
};


